import { useTranslation } from 'react-i18next'
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'

const AddThemeDialog = ({ open, onClose, themeForm, setThemeForm, onAdd }) => {
  const { t } = useTranslation('common')

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('syllabus.new_theme_dialog')}</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          label={t('syllabus.theme_label')}
          value={themeForm.title}
          onChange={(e) => setThemeForm((f) => ({ ...f, title: e.target.value }))}
          margin="normal"
        />
        <TextField
          type="number"
          fullWidth
          label={t('syllabus.hours_label')}
          value={themeForm.hours}
          onChange={(e) => setThemeForm((f) => ({ ...f, hours: Number(e.target.value) }))}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="contained" onClick={onAdd}>
          {t('syllabus.add_btn')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddThemeDialog
